// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1_off","cls2":"AutoCompleteResults-cls2_OsJ AutoCompleteResults-cls1_off"};